import { render, staticRenderFns } from "./surface_post_words.vue?vue&type=template&id=cc356232&"
import script from "./surface_post_words.vue?vue&type=script&lang=js&"
export * from "./surface_post_words.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_words.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports